import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ManageJournalDetail: React.FC<Props> = ({ view }: Props) => {
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.MAGAZINE}
            view={view}
            menu_name={'จัดการวารสาร'}
            menu_name_detail='เพิ่มวารสาร'
            menu_name_detail_edit='รายละเอียดวารสาร'
            menu_path_name={routeName.e_library.manage_journal}
        />
    )
}

export default ManageJournalDetail